<template>

<section class="Cd564h" id="guests">
    <p class="Ytegx748"><span style="font-size:20px">DISTINGUISHED</span> HOSTS</p>
        <div class="container Tvuu7fd">
    <div class="row vuu7fd">
       <div class="col-lg-4 "><p class="Hsr7dh">
        H.E AZALI ASSOUMANI
       </p>
    <p class="Idhh75">Chairperson of the 
    
    African Union</p>
    </div>
       <div class="col-lg-8 img__fill c5fgew3332 "><img src="../../assets/2023/azali.svg" alt=""></div> 
    </div>
    <div class="row vuu7fd">
        <div class="col-lg-8 img__fill c5fgew3334"><img src="../../assets/2023/sahle.svg" alt=""></div> 
       <div class="col-lg-4 ">
        
        <p class="Hsr7dh">
    H.E. Sahle-Work Zewde
        </p>
    <p class="Idhh75">
        President of the Federal Democratic
    
    Republic of Ethiopia
    
      
    </p>
    
        <p class="img67ufkk"> . . . . .</p>
        <p class="Idhh75 dfdf445d">   Distinguished Chair of Ceremonies</p>
    </div>
      
    </div>
    
    <div class="row vuu7fd">
       <div class="col-lg-4 ">
        <p class="Hsr7dh">
        H.E. Nana
    
    Akufo-Addo
       </p>
    <p class="Idhh75">
        AU Champion of Financial Institutions</p>
        <p class="img67ufkk"> . . . . .</p>
        <p class="Idhh75 dfdf445d"> Guest of Honour</p>
    
    </div>
       <div class="col-lg-8 img__fill c5fgew3335 "><img src="../../assets/2023/nana.svg" alt=""></div> 
    </div>
    
        </div>  
    <!-- ------------------------------------- -->
<div class="container">
    <div class="Uyhhf7 ">
<div class="Htddj869 ">
<div class="y6hhf411p img__fill">
<img src="../../assets/2023/azali.svg" alt="">
</div>
<div class="pGyTT6477">
    <p class="Iu87nn">H.E. Azali Assoumani</p>
<p class="HGG7d7">Chairperson of the African Union</p>    
</div>
</div>
<div class="Htddj869 ">
<div class="y6hhf411p img__fill">
<img src="../../assets/2023/sahle.svg" alt="">
</div>
<div class="pGyTT6477">
    <p class="Iu87nn">    H.E. Sahle-Work Zewde</p>
<p class="HGG7d7">President of the Federal Democratic Republic of Ethiopia</p>
<p class="TY76hhe">Distinguished Chair of Ceremonies</p>    
</div>
</div>
<div class="Htddj869 ">
<div class="y6hhf411p img__fill">
<img src="../../assets/2023/nana.svg" alt="">
</div>
<div class="pGyTT6477">
    <p class="Iu87nn">   H.E. Nana Akufo-Addo</p>
<p class="HGG7d7">AU Champion of Financial Institutions</p>
<p class="TY76hhe">Guest of Honour</p>  
</div>
</div>
    </div>
</div>



<!--------------------------------->
<div class="container m_8YyhHH">
<div class="row ">
<div class="col-12 __mg-auto ">
<div class="img__fill Rtfc5ee ">
<img src="../../assets/2023/azali.svg" alt="">
</div>
</div>
<div class="col-12  __mg-auto ">
<div class="Rtfc5eeT ">
<p class="Iu87nn">H.E. Azali Assoumani</p>
<p class="HGG7d7">Chairperson of the African Union</p>
</div>    
</div>
</div>

<div class="row ">
<div class="col-12 __mg-auto ">
<div class="img__fill Rtfc5ee ">
<img src="../../assets/2023/sahle.svg" alt="">
</div>
</div>
<div class="col-12  __mg-auto ">
<div class="Rtfc5eeT ">
<p class="Iu87nn">    H.E. Sahle-Work Zewde</p>
<p class="HGG7d7">President of the Federal Democratic Republic of Ethiopia</p>
<p class="TY76hhe">Distinguished Chair of Ceremonies</p>

</div>    
</div>
</div>
<div class="row ">
<div class="col-12 __mg-auto ">
<div class="img__fill Rtfc5ee ">
<img src="../../assets/2023/nana.svg" alt="">
</div>
</div>
<div class="col-12  __mg-auto ">
<div class="Rtfc5eeT ">
<p class="Iu87nn">   H.E. Nana Akufo-Addo</p>
<p class="HGG7d7">AU Champion of Financial Institutions</p>
<p class="TY76hhe">Guest of Honour</p>

</div>    
</div>
</div>
</div>


        <div class="pK09jh img__fill ">
                <img src="../../assets/2023/rings_bottom.svg" alt="">
    
            </div>    
        </section>
  
</template>

<script>
  /* eslint-disable */

export default {
name:'Guests'
}
</script>

<style>
.pGyTT6477{padding-top:1em}
.y6hhf411p{width:350px;height:350px}
.Uyhhf7 {
  display: flex;
  justify-content: center;
  align-items: left;
  flex-wrap: wrap;
}
.Htddj869{width:350px;height:500px;margin:auto}
.Rtfc5ee img, .y6hhf411p img{ filter: grayscale(100%);}
.Iu87nn{font-family:"Montserrat-bold";text-transform: uppercase;color:#00B56D;font-size:17px}
.TY76hhe,.HGG7d7{font-family:"Montserrat-bold";text-transform: uppercase;color:#000;font-size:13px;position:relative;top:-0.5em}
.TY76hhe{position: relative;top:-1.5em;font-size:11px;color:#00B56D;}
.m_8YyhHH .row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.Rtfc5ee{
    width:220px;height:220px; margin: auto;
}
.Rtfc5eeT{
    width:220px;height:auto; margin: auto;
}
.v8e9djk .img67ufkk{position: relative;top:-0.5em}
.v8e9djk .dfdf445d{position: relative;top:-2em}
.v8e9djk .Hsr7dh{color:#00B56D;font-size:20px;position: relative;top:30%;font-family:"Montserrat-extra-bold";text-align: left;text-transform:uppercase;padding-top:1em}
.Idhh75.dfdf445d{padding-top: 2em;}
    .img67ufkk{font-size:40px;color:#00B56D;position: relative;top:30%;text-align: left;}
    .Idhh75{font-size:13px;position: relative;top:30%;font-family:"Montserrat-bold";text-transform:uppercase;font-weight:400;text-align: left;color:#000}
    .Hsr7dh{color:#00B56D;font-size:27px;position: relative;top:30%;font-family:"Montserrat-extra-bold";text-align: left;text-transform:uppercase;}
   .c5fgew3332 {
    width: 608px;
height: 263px

}
.c5fgew3331{width: 490px;
height: 474px

}
.c5fgew3334{ width: 488px;
height: 488px

}
.c5fgew3335{width: 490px;
height: 474px

}

.c5fgew3332 img,.c5fgew3331 img, .c5fgew3334 img,.c5fgew3335 img{  filter: grayscale(100%);
}
    .vuu7fd {padding-bottom: 4em;}

    /*mobile-tablet */
@media (max-width: 768px) { 
.Tvuu7fd{display: none !important;;}
.v8e9djk{display:block!important}
.m_8YyhHH{display:none!important}
.Uyhhf7{display: block!important;;}


}
@media (max-width: 576px) { 

}

@media (min-width: 576px) { 
}

@media (min-width: 768px) {   
  .v8e9djk{display:none!important}
  .m_8YyhHH{display:none!important}
 .Uyhhf7{display: flex!important;;}
 .Tvuu7fd{display: none!important;}


}

@media (min-width: 992px) { 
.Uyhhf7{display: none!important;;}
.m_8YyhHH{display:none!important}
.Tvuu7fd{display: block!important;}


}
</style>
